import useFetch from "../../../hooks/useFetch";
import { Products } from "../../Products/Products";


export function RelatedProducts({ productId, categoryId }){

    const { data } = useFetch(
        `/api/products?populate=*&filters[id][$ne]=${productId}&filters[categories][id]=${categoryId}&
        pagination[sart]=0&pagination[limit]=4`
    )

    return(
        <div className="related-products">
            <Products headingText="Realted Products" products={data} />
        </div>
    )
}